import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getJWT } from '@pocapan/shared/utils/etcUtils';

const GuestRoute = () => {
  const token = getJWT();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const initValue = searchParams.get('init');
  const isInitMode = initValue === 'true';
  
  if (isInitMode) {
    return <Outlet />;
  }

  if (token) {
    // 토큰이 있으면 홈으로 이동
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
};

export default GuestRoute;
